import * as types from '../mutation-types';
import { unionState } from '../helpers';

const state = () => ({
	users: [],
});

const actions = {
	fetchAll({ commit }) {
		return axios.get('/api/users').then(response => {
			commit(types.STORE_USERS, response.data);

			return response.data;
		});
	},

	fetch({ commit }, { userId }) {
		return axios.get(`/api/users/${userId}`).then(response => {
			commit(types.STORE_ONE_USER, response.data);

			return response.data;
		});
	},

	update({ commit }, { user_id, password, password_confirmation }) {
		const formData = new FormData();
		formData.append('user_id', user_id);
		formData.append('password', password);
		formData.append('password_confirmation', password_confirmation);

		formData.append('_method', 'PUT');

		return axios.post(`/api/users/changepassword`, formData, formData, {
			headers: {
				'Content-Type': 'multipart/form-data'
			}
		});
	},

	toggle({ commit }, { userId }) {
		return axios.post(`/api/users/${userId}/toggle`).then(() => {
			commit(types.TOGGLE_USER, userId);
		});
	}
};

const mutations = {
	[types.STORE_USERS](state, users) {
		state.users = unionState(state.users, users);
	},

	[types.STORE_ONE_USER](state, user) {
		state.users = unionState(state.users, [user]);
	},

	[types.TOGGLE_USER](state, id) {
		const user = state.users.find(c => c.id === id);
		user.banned = !user.banned;
	},
};

const getters = {
	getById: state => id => state.users.find(f => f.id === id),
};

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
};